import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private keyclockService: KeycloakService) {}

  public sessionValid: boolean = true;

  public userDetails : any;

  getLoggedUser() {
    try {
      const userDetails =
        this.keyclockService.getKeycloakInstance().idTokenParsed;
      return userDetails;
    } catch (error) {
      return undefined;
    }
  }

  get token() {
    // return this.keyclockService.getKeycloakInstance().token;
    return '';
  }

  logout() {
    this.keyclockService.logout();
  }

  redirectToProfile() {
    this.keyclockService.getKeycloakInstance().accountManagement();
  }

  getRoles(): string[] {
    return this.keyclockService.getUserRoles();
  }

  forceLogout() {
    this.keyclockService.logout();
  }

  isLoggedIn(): Promise<boolean> {
    return this.keyclockService.isLoggedIn();
  }

  loadUserProfile(){
    this.keyclockService.loadUserProfile().then((res) => {
      console.log(res)
      this.userDetails = res;
    })
  }
}
